// 同意文言一覧
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { Row, Col, Modal } from 'react-bootstrap';
import axios from '../../axios';
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import ja from 'date-fns/locale/ja';
import LoadingModal from '../../molecules/LoadingModal';
import Messages from '../../molecules/Messages';
import { handleBrowserBack } from '../../BrowserBack';
import { KWANKGM10060A01, KWANKGM10090A02_Validate, KWANKGM10090A02, KWANKGM10100A01, KWANKGM10100A01_Validate } from '../../const/api_modules';
import { init_error_message, register_button_hidden_status, KWANKGM10100, KWANKGM10110_Complete, KWANKGM10110_Delete, ValidDelete } from '../../const/CustomerDocumentEdit';
import { SelectedCustomer, SelectedAuthorizer, ResponseDetail, CustomersUserList, PostDetail } from '../../types/CustomerDocumentEdit';
import ModalCustomerSelect from '../../molecules/ModalCustomerSelect';
import ModalAuthorizerSelect from '../../molecules/ModalAuthorizerSelect';
import { api_response_type } from '../../Const';

const CustomerDocumentEdit = () => {
  // URLパラメータを取得する
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const document_id = url_params.get('id');

  const [is_loading, setIsLoading] = useState(false);
  const [error_message, setErrorMessage] = useState(init_error_message);
  // 編集(確認)切り替えフラグ
  const [is_confirm, setIsConfirm] = useState(false);

  // dataプロパティを取得
  const node = document.getElementById('customer-document-edit');
  const login_user_id = node?.dataset.user_id;
  const login_user_name = node?.dataset.login_user_name;
  // 識別コード
  const user_ident_lv1_cd = node?.dataset.ident_lv1_cd;
  const user_ident_lv2_cd = node?.dataset.ident_lv2_cd;
  const user_ident_lv3_cd = node?.dataset.ident_lv3_cd;
  // 支店番号
  const user_office_id = node?.dataset.office_id

  // モーダルの表示制御
  // 削除確認
  const [del_modal_show, setDelModalShow] = useState(false);
  // 対象顧客選択
  const [customer_modal_show, setCustomerModalShow] = useState(false);
  // 承認者選択
  const [authorizer_modal_show, setAuthorizerModalShow] = useState(false);

  // 各種入力状態の保持
  // JA名
  const [ja_name, setJaName] = useState('');
  // 店舗名
  const [office_name, setOfficeName] = useState('');
  // タイトル
  const [title, setTitle] = useState('');
  // コメント
  const [comment, setComment] = useState('');
  // ファイル
  const [file_name, setFileName] = useState('');
  const [file_body, setFileBody] = useState<File|null>(null);
  // 顧客リスト
  const [selected_customer_list, setSelectedCustomerList] = useState<SelectedCustomer[]>([]);
  // 掲載開始日
  const [start_date, setStartDate] = useState<Date|null>(null);
  // 掲載終了日
  const [end_date, setEndDate] = useState<Date|null>(null);
  // 承認者リスト
  const [selected_authorizer_list, setSelectedAuthorizerList] = useState<SelectedAuthorizer[]>([]);

  // 画面上に表示しないが、モジュールをコールする時に必要になるプロパティ
  // 識別コード
  const [ident_lv1_cd, setIdentLv1Cd] = useState(user_ident_lv1_cd);
  const [ident_lv2_cd, setIdentLv2Cd] = useState(user_ident_lv2_cd);
  const [ident_lv3_cd, setIdentLv3Cd] = useState(user_ident_lv3_cd);
  // 店舗コード
  const [code, setCode] = useState<number|null>(null);
  // ステータス
  const [status, setStatus] = useState<number>(1);

  // TODO KWANKGM10060A01のレスポンスのモックであるためモジュールが提供されたら削除する
  const mock_KWANKGM10060A01 = {
    data: {
      result: true,
      message: '',
      detail: {
        'customers_document': {
          id: 1,
          ident_lv1_cd: '0000',
          ident_lv2_cd: '5172',
          ident_lv3_cd: '0000',
          code: 1,
          group_name: 'JA東京みどり',
          offices_name: 'サンプル店舗',
          title: '融資実行のご案内',
          comment: '融資実行が完了しました。詳細内容については添付ファイルをご確認ください。',
          file_name: 'bunsho.pdf',
          user_list: [
            {
              user_id: 1,
              user_name: '文書太郎',
              email: 'taro@test.jp',
            },
          ],
          start_date: '2020-04-01',
          end_date: '2023-11-01',
          create_user_id: 1,
          create_user_name: '登録者',
          authorizer_name: '職員一郎',
          authorizer_id: 1,
          status: 1,
          updated_at: '2020-06-01',
        },
      }
    }
  };

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 初期処理
    requestKWANKGM10060A01();
    requestUserInfo();
  }, []);

  // document_idがセットされている場合、KWANKGM10060A01をコールしてデータを取得する
  const requestKWANKGM10060A01 = async () => {
    try {
      // document_idがnull、またはundefinedの場合は処理をしない
      if (document_id === null || typeof document_id === 'undefined') {
        return;
      }
      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        reception_id: '',
        reception_cd: null,
        module_name: KWANKGM10060A01,
        detail: [
          { id: 0, name: 'id', value: document_id }
        ]
      });

      if (!response.data.result) {
        throw({ response: response });
      }

      // レスポンスを入力項目にセットする
      setJaName(response.data.detail.customer_document.group_name);
      setOfficeName(response.data.detail.customer_document.offices_name);
      setTitle(response.data.detail.customer_document.title);
      setComment(response.data.detail.customer_document.comment);
      setFileName(response.data.detail.customer_document.file_name);
      setStartDate(new Date(response.data.detail.customer_document.start_date));
      setEndDate(new Date(response.data.detail.customer_document.end_date));
      setStatus(response.data.detail.customer_document.status);
      setIdentLv1Cd(response.data.detail.customer_document.ident_lv1_cd);
      setIdentLv2Cd(response.data.detail.customer_document.ident_lv2_cd);
      setIdentLv3Cd(response.data.detail.customer_document.ident_lv3_cd);
      setCode(response.data.detail.customer_document.code);
      const new_customer_list: SelectedCustomer[] = [];
      response.data.detail.customer_document.user_list.map((user: any) => {
        new_customer_list.push({
          id: String(user.user_id),
          name: user.user_name,
          email: user.email,
          checked: true,
        })
      });
      setSelectedCustomerList(new_customer_list);

      setSelectedAuthorizerList([
        {
          id: String(response.data.detail.customer_document.authorizer_id),
          name: response.data.detail.customer_document.authorizer_name,
        }
      ])
    } catch (error) {
      console.error(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // document_idがセットされていない場合、職員が所属するJA、所属店の情報を取得する
  const requestUserInfo = async () => {
    try {
      // document_idがクエリパラメータで渡されてる場合は処理を行わない
      if (document_id !== null && typeof document_id !== 'undefined') {
        return;
      }

      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/edit/init`, {});
      setIdentLv1Cd(response.data.ident_lv1_cd);
      setIdentLv2Cd(response.data.ident_lv2_cd);
      setIdentLv3Cd(response.data.ident_lv3_cd);
      setJaName(response.data.group_name);
      setOfficeName(response.data.office_name)
      setCode(response.data.office_code);
    } catch (error) {
      console.error(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  }

  // タイトルの入力
  const handleChangeTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };
  // コメントの入力
  const handleChangeComment = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(event.target.value);
  }
  // ファイルの選択
  const handleChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files !== null && event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
      setFileBody(event.target.files[0]);
    } else {
      setFileName('');
      setFileBody(null);
    }
  };
  // 掲載開始日
  const handleChangeStartDate = (date: Date|null) => {
    setStartDate(date);
  };
  // 掲載終了日
  const handleChangeEndDate = (date: Date|null) => {
    setEndDate(date);
  };

  // 対象顧客モーダルのボタン処理
  // 顧客選択ボタン押下
  const handleClickCustomerSelectButton = () => {
    setCustomerModalShow(true);
  };
  // ×ボタン押下
  const handleClickCustomerSelectCancelButton = () => {
    setCustomerModalShow(false);
  }
  // 適用された顧客のリストを取得する
  const handleClickApply = (customer_list: SelectedCustomer[]) => {
    setSelectedCustomerList(customer_list);
  };
  // （編集画面）対象顧客テキストエリアに表示する
  const setCustomerList = () => {
    if (selected_customer_list.length === 0) {
      return('');
    }

    let text = '';
    selected_customer_list.map((customer: SelectedCustomer, index) => {
      if (index > 0) {
        text += '\n';
      }
      text += customer.name;
    }, [selected_customer_list]);

    return(text);
  };
  // （確認画面）対象顧客のリストを表示する
  const displayCustomerList = () => {
    const list: JSX.Element[] = [];

    selected_customer_list.map((customer: SelectedCustomer, index) => {
      list.push(
        <Row key={`display-customer-list-${index}`}>
          <Col md={2}>{customer.name}</Col>
          <Col>{customer.email}</Col>
        </Row>
      )
    });

    return list;
  };
  // （確認画面）ファイル名の表示
  const displayFileName = () => {
    if (file_body === null) {
      return (<></>);
    }

    const url = URL.createObjectURL(file_body);
    return (
      <a href={url} download={file_name}>{file_name}</a>
    );
  };

  // 承認者モーダルのボタン処理
  // 承認者選択ボタン押下
  const handleClickAuthorizerSelectButton = () => {
    setAuthorizerModalShow(true);
  };
  // ×ボタン押下
  const handleClickAuthorizerSelectCancelButton = () => {
    setAuthorizerModalShow(false);
  }
  // 適用された承認者を取得する
  const handleClickAuthorizerApply = (authorizer_list: SelectedAuthorizer[]) => {
    setSelectedAuthorizerList(authorizer_list);
  }
  // 承認者テキストボックスに表示する
  const setAuthorizer = () => {
    if (selected_authorizer_list.length === 0) {
      return ('');
    }

    let text = '';
    selected_authorizer_list.map((authorizer: SelectedAuthorizer) => {
      text = authorizer.name;
    });

    return(text);
  };

  // 削除確認モーダルのボタン処理
  // 削除ボタン押下
  const handleClickDeleteButton = async () => {
    try {
      setIsLoading(true);
      setErrorMessage(init_error_message);

      // ファイルをBase64に変換
      if (file_body !== null) {
        const freader = new FileReader();
        freader.readAsDataURL(file_body as Blob);
        freader.onload = async (e) => {
          sendCommonApiWithFile(freader, KWANKGM10090A02_Validate, ValidDelete);
        }
      } else {
        sendCommonApiWithFile(null, KWANKGM10090A02_Validate, ValidDelete);
      }
    } catch (error) {
      console.error(error.response.data.message);
      // バリデーションエラーメッセージを表示する
      setValidErrorMessage(error.response.data.detail);
    } finally {
      setIsLoading(false);
    }
  };
  // キャンセルボタン押下
  const handleClickDeleteCancelButton = () => {
    setDelModalShow(false);
  };
  // OKボタン押下
  const handleClickDeleteOkButton = async () => {
    try {
      setIsLoading(true);
      setErrorMessage(init_error_message);

      // ファイルをBase64に変換
      if (file_body !== null) {
        const freader = new FileReader();
        freader.readAsDataURL(file_body as Blob);
        freader.onload = async (e) => {
          sendCommonApiWithFile(freader, KWANKGM10090A02, KWANKGM10110_Delete);
        }
      } else {
        sendCommonApiWithFile(null, KWANKGM10090A02, KWANKGM10110_Delete);
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setDelModalShow(false);
      setIsLoading(false);
    }
  };

  // 登録ボタン押下時の処理
  const handleClickRegister = async () => {
    try {
      setIsLoading(true);
      setErrorMessage(init_error_message);

      // userリスト
      const user_list: CustomersUserList[] = [];
      selected_customer_list.map(customer => {
        user_list.push({ user_id: Number(customer.id) })
      });

      // ファイルをBase64に変換
      if (file_body !== null) {
        const freader = new FileReader();
        freader.readAsDataURL(file_body as Blob);
        freader.onload = async (e) => {
          await sendCommonApiWithFile(freader, KWANKGM10100A01_Validate, KWANKGM10100);
        }
      } else {
        await sendCommonApiWithFile(null, KWANKGM10100A01_Validate, KWANKGM10100);
      }
    } catch (error) {
      console.error(error.response.data.message);
      setValidErrorMessage(error.response.data.detail);
    } finally {
      setIsLoading(false);
    }
  };

  // （編集画面）戻るボタン押下時の処理
  const handleClickReturn = () => {
    if (document_id !== null) {
      // 編集の場合はdocument_idの詳細画面に戻る
      location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/detail?id=${document_id}`);
      return;
    }

    // 新規登録の場合は一覧に戻る
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/list`);
  };

  // （確認画面）戻るボタン押下時の処理
  const handleClickReturnToEdit = () => {
    setIsConfirm(false);
  }

  // （確認画面）確認ボタン押下時の処理
  const handleClickConfirm = async () => {
    try {
      setIsLoading(true);

      // ファイルをBase64に変換
      if (file_body !== null) {
        const freader = new FileReader();
        freader.readAsDataURL(file_body as Blob);
        freader.onload = async (e) => {
          await sendCommonApiWithFile(freader, KWANKGM10100A01, KWANKGM10110_Complete);
        }
      } else {
        await sendCommonApiWithFile(null, KWANKGM10100A01, KWANKGM10110_Complete);
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  const sendCommonApiWithFile = async (freader: FileReader|null, module: string, next: string) => {
    try {
      setIsLoading(true);
      setErrorMessage(init_error_message);

      const detail: PostDetail[] = [
        { id: 0, name: 'customers_documents.id', value: document_id },
        { id: 0, name: 'customers_documents.ident_lv1_cd', value: user_ident_lv1_cd },
        { id: 0, name: 'customers_documents.ident_lv2_cd', value: user_ident_lv2_cd },
        { id: 0, name: 'customers_documents.ident_lv3_cd', value: user_ident_lv3_cd },
        { id: 0, name: 'customers_documents.code', value: user_office_id },
        { id: 0, name: 'customers_documents.title', value: title },
        { id: 0, name: 'customers_documents.comment', value: comment },
        { id: 0, name: 'customers_documents.file_name', value: file_name },
        { id: 0, name: 'customers_documents.user', value: [] },
        { id: 0, name: 'customers_documents.start_date', value: start_date !== null ? Moment(start_date).format('YYYY-MM-DD') : '' },
        { id: 0, name: 'customers_documents.end_date', value: end_date !== null ? Moment(end_date).format('YYYY-MM-DD') : '' },
        { id: 0, name: 'customers_documents.authorizer_id', value: selected_authorizer_list[0] ? selected_authorizer_list[0].id : '' },
        { id: 0, name: 'customers_documents.authorizer_name', value: selected_authorizer_list[0] ? selected_authorizer_list[0].name : '' },
        { id: 0, name: 'customers_documents.create_user_id', value: login_user_id },
        { id: 0, name: 'customers_documents.create_user_name', value: login_user_name },
        { id: 0, name: 'customers_documents.status', value: status },
        { id: 0, name: 'customers_documents.file', value: freader !== null ? freader.result as string : null },
      ];
      // ユーザパラメータを追加
      const user_id_list: string[] = [];
      selected_customer_list.map(customer => {
        // user_id_list.push({ user_id: customer.id });
        user_id_list.push(customer.id);
      });
      detail.map(item => {
        if (item.name === 'customers_documents.user') {
          item.value = user_id_list;
        }
      });

      const params = new FormData();
      params.append('reception_id', '0');
      params.append('reception_cd', '');
      params.append('module_name', module);
      params.append('is_json', 'true');
      params.append('detail_json', JSON.stringify(detail)); // JSON文字列をPOSTするためdetailは使わない
      params.append('file', file_body as Blob);

      params.append('customers_documents.id', String(document_id));

      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/common`,
        params,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        }
      );

      switch (next) {
        case KWANKGM10110_Complete: // 顧客宛文書編集（完了）-編集完了
          // 正常レスポンスの場合は完了画面に遷移する
          location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/complete/edit`);
          break;
        case KWANKGM10100: // 登録ボタンクリック後のバリデーション処理
          if (response.data.response_type === api_response_type.validation) {
            // バリデーションエラーの時はエラーメッセージを表示
            setValidErrorMessage(response.data.detail);
          } else if (response.data.response_type === api_response_type.page_transition || response.data.response_type === api_response_type.auto_input) {
            // 画面を顧客宛文書編集(確認)に切り替える
            setIsConfirm(true);
          } else {
            // エラーの場合はエラー処理へ
            alert(response.data.message);
          }
          break;
        case ValidDelete: // 削除のバリデーション
          if (response.data.response_type === api_response_type.validation) {
            // バリデーションエラーの時はエラーメッセージを表示
            setValidErrorMessage(response.data.detail);
          } else if (response.data.response_type === api_response_type.page_transition || response.data.response_type === api_response_type.auto_input) {
            // 削除確認ポップアップを表示する
            setDelModalShow(true);
          } else {
            // エラーの場合はエラー処理へ
            alert(response.data.message);
          }
          break;
        case KWANKGM10110_Delete: // 顧客宛文書編集（完了）-削除完了
          // 正常レスポンスの場合は、顧客宛文書編集(完了)に遷移する
          location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/complete/delete`);
          break;
      }
    } finally {
      setIsLoading(false);
    }
  }

  // バリデーションエラーメッセージを表示する
  const setValidErrorMessage = (detail: ResponseDetail[]) => {
    // 項目毎のバリデーションエラーメッセージを反映する
    if (detail.length > 0) {
      const new_error_message = {...init_error_message};
      detail.map((item: any) => {
        if (item.form_name === 'customers_documents.title') {
          new_error_message.title = item.message;
        } else if (item.form_name === 'customers_documents.comment') {
          new_error_message.comment = item.message;
        } else if (item.form_name === 'customers_documents.file') {
          new_error_message.file = item.message;
        } else if (item.form_name === 'customers_documents.user') {
          new_error_message.target_customer = item.message;
        } else if (item.form_name === 'customers_documents.start_date') {
          new_error_message.start_date = item.message;
        } else if (item.form_name === 'customers_documents.end_date') {
          new_error_message.end_date = item.message;
        } else if (item.form_name === 'customers_documents.authorizer_id') {
          new_error_message.authorizer_id = item.message;
        }
      });
      setErrorMessage(new_error_message);
    }
  };

  // 登録ボタンの表示制御
  const isVisibleRegisterButton = () => {
    const today = Moment();
    const end = end_date !== null ? Moment(end_date) : null;

    if (
      (status !== null && register_button_hidden_status.includes(Number(status))) // 承認済みである
      && (end !== null && today.isAfter(end)) // 日付が掲載終了日付より後である
    ) {
      return false;
    }
    return true;
  };

  // POSTパラメータを生成する
  const setPostParam = (module_name: string) => {
    // userリスト
    const user_list: number[] = [];
    selected_customer_list.map(customer => {
      user_list.push(Number(customer.id));
    });

    return {
      reception_id: '0',
      reception_cd: null,
      module_name: module_name,
      is_json: true,
      'customers_documents.id': { val: document_id },
      'customers_documents.ident_lv1_cd': { val: user_ident_lv1_cd },
      'customers_documents.ident_lv2_cd': { val: user_ident_lv2_cd },
      'customers_documents.ident_lv3_cd': { val: user_ident_lv3_cd },
      'customers_documents.code': { val: '201' },
      'customers_documents.title': { val: title },
      'customers_documents.comment': { val: comment },
      'customers_documents.file_name': { val: file_name },
      'customers_documents.user': { val: user_list },
      'customers_documents.start_date': { val: start_date !== null ? Moment(start_date).format('YYYY-MM-DD') : '' },
      'customers_documents.end_date': { val: end_date !== null ? Moment(end_date).format('YYYY-MM-DD') : '' },
      'customers_documents.authorizer_id': { val: selected_authorizer_list[0].id },
      'customers_documents.authorizer_name': { val: selected_authorizer_list[0].name },
      'customers_documents.create_user_id': { val: login_user_id },
      'customers_documents.create_user_name': { val: login_user_name },
      'customers_documents.status': { val: status },
    };
  };

  // 掲載終了日の選択可能日付を設定する
  const setMinEndDate = () => {
    const today = Moment(new Date());
    const now_start = start_date !== null ? Moment(start_date) : null;

    if (now_start === null) {
      // 開始日がnullの場合は、当日から選択可能
      return new Date(today.format('YYYY/MM/DD'));
    } else if (now_start !== null && now_start.isBefore(today)) {
      // 開始日が当日より前で設定されている場合、当日から選択可能
      return new Date(today.format('YYYY/MM/DD'));
    } else {
      // 開始日が当日、または翌日以降である場合は、開始日から選択可能
      return new Date(now_start.format('YYYY-MM-DD'));
    }
  };

  return (
    <div className="maintenance">
      <div className="title">顧客宛文書</div>
      <div className="maintenance_container">
        <div className="contents">
          <div className="page-title">顧客宛文書編集{is_confirm && '(確認)'}</div>
          <table className="detail_table">
            <tbody>
              <tr>
                <th>JA名</th>
                <td>{ja_name}</td>
              </tr>
              <tr>
                <th>店舗名</th>
                <td>{office_name}</td>
              </tr>
              <tr>
                <th>タイトル</th>
                <td>
                  {is_confirm ?
                    (
                      <>{title}</>
                    ) : (
                      <>
                        <input type="text" className={`form-control ${error_message.title && 'textarea-error'}`}  value={title} onChange={handleChangeTitle} />
                        <Messages valid_msg={error_message.title} />
                      </>
                    )
                  }
                </td>
              </tr>
              <tr>
                <th>コメント</th>
                <td>
                  {is_confirm ? 
                    (
                      <>{comment}</>
                    ) : (
                      <>
                        <textarea rows={5} value={comment} className={`input-comment ${error_message.comment && 'textarea-error'}`} onChange={handleChangeComment}></textarea>
                        <Messages valid_msg={error_message.comment} />
                      </>
                    )
                  }
                </td>
              </tr>
              <tr>
                <th>ファイル名</th>
                <td>
                  {is_confirm ? (
                    <>{displayFileName()}</>
                  ) : (
                    <>
                      <div>{file_name}</div>
                      <input type="file" className={`form-control ${error_message.file && 'textarea-error'}`} onChange={handleChangeFile} />
                      <Messages valid_msg={error_message.file} />
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <th>対象顧客</th>
                <td>
                  {is_confirm ? (
                    <>{displayCustomerList()}</>
                  ) : (
                    <>
                      <Row>
                        <Col md={7}>
                          <textarea
                            cols={50}
                            rows={5}
                            disabled={true}
                            value={setCustomerList()}
                            className={`form-control ${error_message.target_customer && 'textarea-error'}`} 
                          />
                        </Col>
                        <Col>
                          <a className={"btn btn-mini btn-success"} onClick={handleClickCustomerSelectButton}>選択</a>
                        </Col>
                      </Row>
                      <Messages valid_msg={error_message.target_customer} />
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <th>掲載開始日</th>
                <td>
                  {is_confirm ? (
                    <>{start_date !== null ? Moment(start_date).format('YYYY-MM-DD') : <></>}</>
                  ) : (
                    <>
                      <DatePicker
                        className={`form-control ${error_message.start_date && 'textarea-error'}`}
                        onChange={handleChangeStartDate}
                        selected={start_date}
                        dateFormat="yyyy-MM-dd"
                        placeholderText=''
                        locale={ja}
                        minDate={new Date()}
                      />
                      <Messages valid_msg={error_message.start_date} />
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <th>掲載終了日</th>
                <td>
                  {is_confirm ? (
                    <>{end_date !== null ? Moment(end_date).format('YYYY-MM-DD') : <></>}</>
                  ) : (
                    <>
                      <DatePicker
                        className={`form-control ${error_message.end_date && 'textarea-error'}`}
                        onChange={handleChangeEndDate}
                        selected={end_date}
                        dateFormat="yyyy-MM-dd"
                        placeholderText=''
                        locale={ja}
                        minDate={setMinEndDate()}
                      />
                      <Messages valid_msg={error_message.end_date} />
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <th>承認者</th>
                <td>
                  {is_confirm ? (
                    <>{setAuthorizer()}</>
                  ) : (
                    <>
                      <Row>
                        <Col md={7}>
                          <input type="text" className={`form-control ${error_message.authorizer_id && 'textarea-error'}`} disabled={true} value={setAuthorizer()} />
                        </Col>
                        <Col>
                          <a className={"btn btn-mini btn-success"} onClick={handleClickAuthorizerSelectButton}>選択</a>
                        </Col>
                      </Row>
                      <Messages valid_msg={error_message.authorizer_id} />
                    </>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          {!is_confirm && (
            <Row className="footer-button-block">
              <Col className="footer-btn footer-button-left">
                <a
                  className="btn btn-mini btn-outline-success btn-text-color btn-bg-white"
                  onClick={handleClickReturn}
                >
                  戻る
                </a>
              </Col>
              <Col className="footer-btn">
                <a className={`btn btn-mini btn-danger ${document_id === null && 'dom-hidden'}`} onClick={handleClickDeleteButton}>削除</a>
              </Col>
              <Col className="footer-btn footer-button-right">
                <a className={`btn btn-mini btn-success ${!isVisibleRegisterButton() && 'dom-hidden'}`} onClick={handleClickRegister}>登録</a>
              </Col>
            </Row>
          )}
        </div>
        {is_confirm && (
          <Row className="footer-button-block mt-3">
            <Col className="footer-btn">
              <a className="btn btn-mini btn-outline-success btn-text-color btn-bg-white"
                onClick={handleClickReturnToEdit}
              >
                戻る
              </a>
            </Col>
            <Col className="footer-btn">
              <a className={`btn btn-mini btn-success ${!isVisibleRegisterButton() && 'dom-hidden'}`} onClick={handleClickConfirm}>確認</a>
            </Col>
          </Row>
        )}
      </div>
      <LoadingModal show={is_loading} />
      {/* 削除確認ダイアログ */}
      <Modal
        className="d-flex justify-content-center align-items-center modal-delete-comfirm"
        show={del_modal_show}
        animation={false}
        onHide={() => {}}
      >
        <div className="modal fade show" id="document_display_delete_modal" aria-modal="true">
          <div className="modal-dialog-centered">
            <div className="modal-content modal-dialog">
              <div className="modal-body">
                <p>この顧客宛文書を削除します。よろしいですか？</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-success col-md-3" onClick={handleClickDeleteCancelButton}>
                  キャンセル
                </button>
                <a className="btn btn-important col-md-3" onClick={handleClickDeleteOkButton}>
                  OK
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* 顧客選択ダイアログ */}
      <ModalCustomerSelect
        show={customer_modal_show}
        handleCancel={handleClickCustomerSelectCancelButton}
        handleApply={handleClickApply}
      />
      {/* 承認者選択ダイアログ */}
      <ModalAuthorizerSelect
        show={authorizer_modal_show}
        handleCancel={handleClickAuthorizerSelectCancelButton}
        handleApply={handleClickAuthorizerApply}
      />
    </div>
  );
};

if (document.getElementById('customer-document-edit')) {
  render(<CustomerDocumentEdit />, document.getElementById('customer-document-edit'));
}
